'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const JPEGIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="JPEGIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Image-File-Landscape--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Image File Landscape Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M6.5 9.5a2 2 0 1 0 4 0 2 2 0 1 0 -4 0Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M13.924 12.178a0.5 0.5 0 0 0 -0.848 0L10.437 16.4l-1.075 -1.722a0.5 0.5 0 0 0 -0.848 0L5.5 19.5h13Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M21.207 4.5a1 1 0 0 1 0.293 0.707V22.5a1 1 0 0 1 -1 1h-17a1 1 0 0 1 -1 -1v-21a1 1 0 0 1 1 -1h13.293a1 1 0 0 1 0.707 0.293Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

JPEGIcon.propTypes = {
  sx: PropTypes.object
}
